export const howItWorks = {
  hero: {
    badge: "Complete guide",
    title: "How does DONKEY TRAVEL work?",
    subtitle:
      "Discover step by step how to exchange your Airbnb property with other owners and travel for free across Europe.",
    cta: "Get started now",
    learnMore: "See the steps",
  },
  stats: {
    properties: "Available properties",
    exchanges: "Completed exchanges",
    countries: "Countries covered",
    satisfaction: "Satisfaction",
  },
  steps: {
    badge: "The process",
    title: "Your exchange in 7 steps",
    subtitle:
      "A simple and secure journey, from sign-up to your first free trip",
    step1: {
      title: "Create your profile (15 min)",
      description:
        'It\'s the "longest" step: 15 minutes to create your profile. A small effort for years of free vacations and happiness!',
      highlight1: "Subscription required",
      highlight2: "Complete listing with photos",
      highlight3: "Identity verification",
      badge: "Quick sign-up",
    },
    step2: {
      title: "Explore and find your ideal destination",
      description:
        "Browse our Europe interactive map and find verified host members in the club. Filter by destination, dates, property type, and amenities to organize your exchange.",
      highlight1: "Europe interactive map with advanced filters",
      highlight2: "Search by destination, dates and amenities",
      highlight3: "Verified host members in available European countries",
      badge: "Smart search",
    },
    step3: {
      title: "Propose an exchange and negotiate",
      description:
        "Contact the owner you're interested in and propose an exchange. Negotiate dates and duration in a friendly spirit. 10 nights for 5? Anything is possible!",
      highlight1: "Integrated and secure messaging",
      highlight2: "Flexible duration negotiation",
      highlight3: "Verified profiles and reviews available",
      badge: "Easy negotiation",
    },
    step4: {
      title: "Confirm dates and sync your calendars",
      description:
        "Once the agreement is reached, confirm the exchange dates. Your Airbnb and DONKEY TRAVEL calendars sync automatically to avoid any booking conflicts.",
      highlight1: "Automatic synchronization with Airbnb",
      highlight2: "Reminders and notifications before the stay",
      highlight3: "Flexible modification up to 48h before",
      badge: "Synced calendar",
    },
    step5: {
      title: "Amicable PDF contract sent to both hosts",
      description:
        "DONKEY TRAVEL generates an amicable agreement in PDF and sends it to both hosts. Once the first exchange is completed, you have 24 months to complete the return exchange.",
      highlight1: "Amicable PDF contract sent automatically to both hosts",
      highlight2: "Summary document with validated dates and conditions",
      highlight3:
        "24 months to complete the return exchange after the first stay",
      badge: "PDF contract",
    },
    step6: {
      title: "Travel and enjoy your free stay!",
      description:
        "The big day is here! Settle into your exchange property and enjoy authentic holidays. After your stay, leave a review to help the community.",
      highlight1: "Personalized welcome by the owner",
      highlight2: "Local guide with recommendations",
      highlight3: "Review system after each exchange",
      badge: "Bon voyage!",
    },
  },
  advantages: {
    badge: "Our advantages",
    title: "Why choose DONKEY TRAVEL?",
    subtitle:
      "A platform designed for Airbnb owners who want to travel differently",
    items: {
      security: {
        title: "Maximum security",
        description:
          "All members are verified Airbnb owners. Controlled identity, consultable reviews and insurance included for each exchange.",
      },
      savings: {
        title: "Considerable savings",
        description:
          "Travel for free by exchanging your nights. Save an average of €2,500 per year on accommodation costs.",
      },
      community: {
        title: "Trusted community",
        description:
          "Join our community of travelers. Share your experiences, exchange tips, and build lasting connections.",
      },
      support: {
        title: "7/7 support",
        description:
          "Our team is available at all times to assist you. Live chat, email and phone for complete assistance.",
      },
      quality: {
        title: "Quality properties",
        description:
          "Each property is verified and rated by the community. High standards to guarantee exceptional stays.",
      },
      global: {
        title: "European network",
        description:
          "Access verified hosts in available European countries and organize your exchanges with confidence.",
      },
    },
  },
  testimonials: {
    badge: "Testimonials",
    title: "They tested and approved",
    subtitle: "Discover the experiences of our members around the world",
    banner: {
      title: "You too can travel more often!",
      subtitle: "Join the community of hosts who travel differently.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "Paris, France",
        badge: "2 exchanges",
        text: "Thanks to DONKEY TRAVEL, I visited Barcelona, Rome and Amsterdam without paying accommodation. The community is responsive and exchange discussions are easy.",
      },
      marc: {
        name: "Marc",
        location: "Marseille, France",
        badge: "1 exchange",
        text: "The process is incredibly simple. In 3 days, I found a perfect exchange for my summer holidays. The Airbnb sync is a massive plus.",
      },
      leaTom: {
        name: "Léa & Tom",
        location: "Lyon, France",
        badge: "New members",
        text: "What impressed us most is the community. Owners are considerate, and exchanges take place in an atmosphere of complete trust.",
      },
      dupont: {
        name: "The Duponts",
        location: "Bordeaux, France",
        badge: "3 exchanges",
        text: "Perfect for family travel during school holidays!",
      },
      alex: {
        name: "Alex",
        location: "Berlin, Germany",
        badge: "5 exchanges",
        text: "An incredible network for remote work. I exchange my Berlin loft for sunny apartments.",
      },
      marie: {
        name: "Marie",
        location: "Toulouse, France",
        badge: "4 exchanges",
        text: "No more financial constraints! I go on weekend getaways every month.",
      },
    },
  },
  faq: {
    title: "Frequently asked questions",
    subtitle: "Everything you need to know before getting started",
    items: {
      q1: {
        question: "Is registration paid?",
        answer:
          "Yes. Access to DONKEY TRAVEL requires an annual subscription. 2026 launch offer: EUR25/year instead of EUR50/year.",
      },
      q2: {
        question: "Do I need to be an Airbnb owner to sign up?",
        answer:
          "Yes, DONKEY TRAVEL is reserved for owners with a property listed on Airbnb. This guarantees the quality and reliability of each community member.",
      },
      q3: {
        question: "How are exchanges protected?",
        answer:
          "Each exchange is covered by our partner insurance. Additionally, all members are verified (identity, property, Airbnb reviews) and our support team is available 7/7.",
      },
      q4: {
        question: "Can I exchange with someone in another country?",
        answer:
          "Yes. You can exchange with verified hosts in available European countries, depending on your subscription.",
      },
      q5: {
        question: "What happens if the exchange is cancelled?",
        answer:
          "Our cancellation policy protects both parties. In case of cancellation, we help you find an alternative.",
      },
      q6: {
        question: "How long does an exchange last on average?",
        answer:
          "The duration is totally flexible and negotiated between the two owners. On average, exchanges last between 5 and 14 nights, but some do weekend or full month exchanges.",
      },
    },
  },
  cta: {
    title: "Ready to travel for free?",
    subtitle: "Join our community of travelers.",
    explore: "Explore destinations",
    members: "Active members",
    countries: "Available countries",
    satisfaction: "Satisfaction rate",
  },
};
